class KpPawsNavigation extends HTMLElement {
  #controller;
  #closeTimers = new Map();

  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.#controller = new AbortController();
    const signal = this.#controller.signal;
    const items = this.querySelectorAll('[data-kp-menu-item]');

    for (const item of items) {
      item.addEventListener('pointerenter', () => this.#open(item), { signal });
      item.addEventListener('pointerleave', () => this.#scheduleClose(item), { signal });
      item.addEventListener('focusin', () => this.#open(item), { signal });
      item.addEventListener(
        'focusout',
        (event) => {
          if (!item.contains(event.relatedTarget)) this.#scheduleClose(item, 160);
        },
        { signal }
      );
    }

    this.addEventListener(
      'keydown',
      (event) => {
        if (event.key !== 'Escape') return;

        const openItem = this.querySelector('[data-kp-menu-item][data-open="true"]');
        if (!openItem) return;

        event.preventDefault();
        this.#close(openItem);
        openItem.querySelector('.kp-paws-nav__top-link')?.focus();
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = undefined;
    for (const timer of this.#closeTimers.values()) clearTimeout(timer);
    this.#closeTimers.clear();
    delete this.dataset.ready;
  }

  #open(item) {
    this.#cancelClose(item);

    for (const otherItem of this.querySelectorAll('[data-kp-menu-item][data-open="true"]')) {
      if (otherItem !== item) this.#close(otherItem);
    }

    item.dataset.open = 'true';
    item.querySelector('.kp-paws-nav__top-link')?.setAttribute('aria-expanded', 'true');
  }

  #scheduleClose(item, delay = 450) {
    this.#cancelClose(item);
    const timer = window.setTimeout(() => this.#close(item), delay);
    this.#closeTimers.set(item, timer);
  }

  #cancelClose(item) {
    const timer = this.#closeTimers.get(item);
    if (timer) window.clearTimeout(timer);
    this.#closeTimers.delete(item);
  }

  #close(item) {
    this.#cancelClose(item);
    item.dataset.open = 'false';
    item.querySelector('.kp-paws-nav__top-link')?.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('kp-paws-navigation')) {
  customElements.define('kp-paws-navigation', KpPawsNavigation);
}
